import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController, ModalController } from '@ionic/angular';
import { ModelLocatorService } from 'src/app/services/config/model-locator.service';
import { OnboardService } from 'src/app/services/config/onboard.service';

@Component({
    selector: 'app-mm-onboarding',
    templateUrl: './mm-onboarding.component.html',
    styleUrls: ['./mm-onboarding.component.scss'],
})
export class MmOnboardingComponent implements OnInit {

    @Input() listOnboardingFlow: any = [];
    actualBalao: number = 1;

    constructor(
        private onboardService: OnboardService,
        private modelLocator: ModelLocatorService,
        private menuCtrl: MenuController,
        private router: Router,
        private modalCtrl: ModalController
    ) { }

    ngOnInit() {
        let firstBalao = this.listOnboardingFlow[0];
        if (firstBalao.menu !== '') {
            this.menuCtrl.open(firstBalao.menu);
        }
        if (firstBalao.router !== '') {
            this.router.navigate([firstBalao.router]);
        }
    }

    getActualBalao(): number {
        const index = this.listOnboardingFlow.findIndex((item: any) => {
            return this.modelLocator[item.ballon] === true;
        });

        // Retorna o índice + 1 ou 1 como fallback
        return index !== -1 ? index + 1 : 1;
    }

    async tutorial(item: any) {
        this.setAllBallonFalse();
        this.menuCtrl.close();
        this.modelLocator[item.nextBalloon] = true;
        if (item.router !== '') {
            this.router.navigate([item.router]);
        }
        if (item.menu !== '') {
            this.menuCtrl.toggle(item.menu);
        }

        // If the last item of list
        if (item.id === this.listOnboardingFlow.length) {
            this.close();
            await this.onboardService.saveOnboardChallenge();
        }

    }

    setAllBallonFalse() {
        this.modelLocator.balao_1 = false;
        this.modelLocator.balao_2 = false;
        this.modelLocator.balao_3 = false;
        this.modelLocator.balao_4 = false;
        this.modelLocator.balao_5 = false;
        this.modelLocator.balao_6 = false;
    }

    close() {
        this.modalCtrl.dismiss();
    }

}
